<!-- 任务目录 -->
<template>
  <basicContainer>
    <el-tabs tab-position="top" type="card" v-model="activeName" @tab-click="handleClickmytask">
      <el-tab-pane label="主任务列表" name="first">
        <span slot="label">主任务列表</span>
        <zrw ref="zrwchild"></zrw>
      </el-tab-pane>
      <el-tab-pane label="子任务列表" name="second">
        <span slot="label">子任务列表</span>
        <zirw ref="zirwchild"></zirw>
      </el-tab-pane>
    </el-tabs>
  </basicContainer>
</template>

<script>
import zrw from '@/businessManagement/Taskdirectory/zrw.vue'
import zirw from '@/businessManagement/Taskdirectory/zirw.vue'
export default {
  name: 'Administrativeprocess',
  //   mixins: [crudPageMinix],
  components: {
    zrw, zirw
  },
  data() {
    return {
      activeName: 'first'
    }
  },
  mounted() {

  },
  methods: {
    handleClickmytask() {
      if (this.activeName === 'first') {
        this.$refs.zrwchild.loadData()
      } else {
        this.$refs.zirwchild.loadData()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.iframeMain {
  height: 70vh;
}
:deep(.el-tabs) {
  .el-tabs__header {
    border: none;
  }
  .el-tabs__header .el-tabs__item {
    border: none;
  }
  .el-tabs__header .el-tabs__nav {
    border: none;
    background-color: #f0f2f5;
    border-radius: 5px;
    padding: 3px 15px;
  }
  .el-tabs__header .el-tabs__item.is-active {
    background-color: #ffffff;
    border-radius: 5px;
  }
}
:deep(.el-tag.el-tag--inf) {
  background-color: transparent;
  border-color: transparent;
  color: #909399;
}
</style>
